module.exports = fox._r("fonts/robotocondensed-regular-webfont.ttf", __webpack_public_path__ + "_/_/_/root/fonts/YmeR37a.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/robotocondensed-regular-webfont.ttf
// module id = 185
// module chunks = 4